<div fxLayout="row wrap" fxLayoutAlign="center" class="p-20">
    <ng-container *ngIf="cargando">
        <div fxLayout="column" fxLayoutAlign="space-between center">
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
        </div>
    </ng-container>
    <!--Pantalla para cuando ya se  ha guardado en la BD-->
    <ng-container *ngIf="!cargando || !cargando_CT">
        <ng-container *ngIf="stored || stored_CT">
            <div class="statusDiv" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                    <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.OK' | translate}}</h2>
                    <mat-icon class="ml-20 s-40">check_circle</mat-icon>
                </div>
            </div>
            <div class="mt-40" fxFlex="100" fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-around stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="mat-elevation-z3 p-20" fxFlex="100" fxFlex.gt-sm="40" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_BD.TITULO' | translate}}</h2>
                    <mat-divider></mat-divider>
                    <div fxLayout="row" fxLayoutAlign="space-between stretch" fxFlex="100" fxFlex.gt-sm="66">
                        <div class="mt-20 mb-20" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50">
                            <div class="h4 secondary-text" style="word-break: break-all;">{{'CERTIFICAR.COLABORADORES.CARD_BD.NUMCOLABS' | translate}}</div>
                            <div class="font-size-54 font-weight-300 line-height-1 mt-8" style="word-break: break-all;">{{colabsEnBD}}</div>
                        </div>
                        <div class="mt-20 mb-20" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="50" style="padding-left: 1%;">
                            <div class="h4 secondary-text" style="word-break: break-all;">{{'CERTIFICAR.COLABORADORES.CARD_BD.NUMCENTER' | translate}}</div>
                            <div class="font-size-54 font-weight-300 line-height-1 mt-8" style="word-break: break-all;">{{CT_EnBD}}</div>
                        </div>

                    </div>
                    <mat-divider></mat-divider>
                    <div class="mt-20">

                        <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.FECHA' | translate}}</div>
                        <!-- <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{fechaCarga_CT |date:"fullDate":'':idiomaActual}}</div> -->
                        <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{fechaCarga_CT|date:"d MMM y H:mm":offsetPipe:idiomaUtc}} ({{fechaCarga_CT|date:'z':offsetPipe:idiomaActual}})</div>
                    </div>
                </div>
                <div class="mat-elevation-z3 p-20" fxFlex="100" fxFlex.gt-sm="40" fxLayout="column" fxLayoutAlign="start stretch">
                    <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_BD.ACCIONES' | translate}}</h2>
                    <mat-divider></mat-divider>
                    <div class="mt-20" fxLayout="column" fxLayoutAlign="start center" fxFlex="100" fxFlex.gt-sm="66">
                        <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.WANNADO' | translate}}</div>
                        <div class="mt-20" fxFlex="50" fxLayout="column" fxLayoutAlign="space-between stretch">
                            <button mat-raised-button class="mb-20 primary" (click)="descargaExcel()" style="word-break: break-all;">
                                {{'CERTIFICAR.COLABORADORES.CARD_BD.BOTONES.DESCARGA' | translate}}
                                <mat-icon class="ml-20">cloud_download</mat-icon>
                            </button>
                            <button mat-raised-button class="mb-20 warn" (click)="descargaExcelCT()" style="word-break: break-all;">
                                {{'CERTIFICAR.COLABORADORES.TITULO' | translate}}
                                <mat-icon class="ml-20">cloud_download</mat-icon>
                             </button>
                            <button mat-raised-button class="mb-20 warn" (click)="borrarColaboradores()" style="word-break: break-all;">
                                {{'CERTIFICAR.COLABORADORES.CARD_BD.BOTONES.ELIMINA' | translate}}
                                <mat-icon class="ml-20">delete_forever</mat-icon>
                             </button>

                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <!-- Pantalla cuando no hay nada en BD-->
        <ng-container *ngIf="!stored && !stored_CT">
            <div class="statusDiv">
                <div *ngIf="files.length == 0" class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                    <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.NOBD' | translate}}</h2>
                    <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
                <div *ngIf="errores.length > 0" class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                    <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.ERROR' | translate}}</h2>
                    <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
                <div *ngIf="files.length > 0 && errores.length == 0" class="roundEdg primary mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                    <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.PROCES' | translate}}</h2>
                    <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
            </div>

            <!-- formulario inicial -->
            <div *ngIf="!cargandoBD && files.length == 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">
                <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_NOBD.TITULO' | translate}}</h2>
                    <mat-divider></mat-divider>
                    <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
                        <mat-icon class="s-30 mr-20">filter_1</mat-icon>
                        <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.1' | translate}}</b></div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center stretch" class="mb-20">
                        <a mat-raised-button class="primary" fxFlex="60" matTooltip="{{'CERTIFICAR.COLABORADORES.CARD_NOBD.TOOLTIP' | translate}}" href="assets/plantillasBD/MX/CollaboratorsDBTemplate_NORM035STP_{{idiomaActual}}.xlsx" download>
                        ParticipantsDBTemplate
                        <mat-icon class="ml-20">save_alt</mat-icon>
                      </a>
                    </div>
                    <mat-divider></mat-divider>
                    <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
                        <mat-icon class="s-30 mr-20">filter_2</mat-icon>
                        <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.2' | translate}}</b></div>
                    </div>
                    <mat-divider></mat-divider>
                    <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
                        <mat-icon class="s-30 mr-20">filter_3</mat-icon>
                        <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_NOBD.PASOS.3' | translate}}</b></div>
                    </div>
                    <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)" *ngIf="totRows == 0 && !cargandoBD" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                        <input hidden type="file" #fileInput (change)="analisisExcel($event)">
                        <h1>{{'CERTIFICAR.COLABORADORES.UPLOAD' | translate}}</h1>
                    </div>
                </div>
            </div>

            <!-- formulario cuando NO hay errores PRIMERA HOJA-->
            <div *ngIf="!guardandoBD && arregloColaboradores.length > 0 && errores.length == 0 && !guardandoBD_CT && arregloCentro_Trabajo.length > 0 && errores_CT.length == 0 " class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">
                <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" *ngFor="let file of files;let i=index" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.TITULO' | translate}}</h2>
                    <mat-divider></mat-divider>
                    <div class="mt-20 mb-20" fxLayout="row" fxLayoutAlign="space-between stretch">
                        <div class="" fxFlex="50" fxLayout="column" fxLayoutAlign="start stretch">
                            <div class="h4 secondary-text" *ngIf="flag_sheet1_errors==0">{{'CERTIFICAR.COLABORADORES.SHEET.NUMBER' | translate}}</div>
                            <div class="font-size-24 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet1_errors==0">{{wsName_co}}</div>
                            <div class="h4 secondary-text" *ngIf="flag_sheet1_errors==0" mat-line>{{'CERTIFICAR.COLABORADORES.CARD_NOERR.NUMCOLABS' | translate}}</div>
                            <div class="font-size-54 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet1_errors==0">{{arregloColaboradores.length}}</div>
                        </div>
                        <div class="" fxFlex="50" fxLayout="column" fxLayoutAlign="start stretch">
                            <div class="h4 secondary-text" *ngIf="flag_sheet2_errors==0">{{'CERTIFICAR.COLABORADORES.SHEET.NUMBER' | translate}}</div>
                            <div class="font-size-24 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet2_errors==0">{{wsName_ct}}</div>
                            <div class="h4 secondary-text mt-20" *ngIf="flag_sheet2_errors==0" mat-line>{{'CERTIFICAR.COLABORADORES.CARD_NOERR.NUMCT' | translate}}</div>
                            <div class="font-size-54 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet2_errors==0">{{arregloCentro_Trabajo.length}}</div>
                        </div>
                    </div>

                    <mat-divider></mat-divider>
                    <div class="mt-20 mb-20">
                        <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.FILENAME' | translate}}</div>
                        <div class="font-size-24 font-weight-300 line-height-1 mt-8" style="word-break: break-all;">{{ file }}</div>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="mt-20 h2 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.GUARDAR' | translate}}</div>
                    <div class="mt-20" fxLayout="row" fxLayoutAlign="space-between stretch">
                        <button mat-raised-button class="warn" fxFlex="45" (click)="deleteAttachment(i,true)">
                            {{'CERTIFICAR.COLABORADORES.CARD_NOERR.BOTONES.NO' | translate}}
                        </button>
                        <button mat-raised-button class="primary" fxFlex="45" (click)="guardarColaboradoresBD()">
                            {{'CERTIFICAR.COLABORADORES.CARD_NOERR.BOTONES.SI' | translate}}
                        </button>
                    </div>
                </div>
            </div>

            <!-- formulario cuando hay errores S -->
            <div *ngIf="errores.length > 0 || errores_CT.length > 0 " class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">
                <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" *ngFor="let file of files;let i=index" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.TITULO' | translate}}</h2>
                    <mat-divider></mat-divider>
                    <div fxLayout="column" fxLayoutAlign="start stretch">
                        <div class="h4 secondary-text" *ngIf="flag_sheet1_errors==1">{{'CERTIFICAR.COLABORADORES.SHEET.NUMBER' | translate}}</div>
                        <div class="font-size-24 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet1_errors==1">{{wsName_co}}</div>
                        <div fxLayout="row" fxLayoutAlign="space-between stretch">
                            <div class="mt-20 mb-20" fxFlex="50">
                                <div class="h4 secondary-text" *ngIf="flag_sheet1_errors==1">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.ROWS_OK' | translate}}</div>
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <div class="font-size-54 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet1_errors==1">{{arregloColaboradores.length}}</div>
                                    <mat-icon class="s-50 ml-20" *ngIf="flag_sheet1_errors==1">done</mat-icon>
                                </div>
                            </div>
                            <div class="mt-20 mb-20" fxFlex="50">
                                <div class="h4 secondary-text" *ngIf="flag_sheet1_errors==1">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.ROWS_NOTOK' | translate}}</div>
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <div class="font-size-54 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet1_errors==1">{{errores.length}}</div>
                                    <mat-icon class="s-50 ml-20" *ngIf="flag_sheet1_errors==1">close</mat-icon>
                                </div>
                                <div class="h4 secondary-text" *ngIf="flag_sheet1_errors==1"><b>{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.MOREINFO' | translate}}</b></div>
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                    <!--SEGUNDA HOJA CUANDO HAY ERRORES-->
                    <div fxLayout="column" fxLayoutAlign="start stretch">
                        <div class="h4 secondary-text" *ngIf="flag_sheet2_errors==1">{{'CERTIFICAR.COLABORADORES.SHEET.NUMBER' | translate}}</div>
                        <div class="font-size-24 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet2_errors==1">{{wsName_ct}}</div>
                        <div fxLayout="row" fxLayoutAlign="space-between stretch">
                            <div class="mt-20 mb-20" fxFlex="50">
                                <div class="h4 secondary-text" *ngIf="flag_sheet2_errors==1">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.ROWS_OK' | translate}}</div>
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <div class="font-size-54 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet2_errors==1">{{arregloCentro_Trabajo.length}}</div>
                                    <mat-icon class="s-50 ml-20" *ngIf="flag_sheet1_errors==2">done</mat-icon>
                                </div>
                            </div>
                            <div class="mt-20 mb-20" fxFlex="50">
                                <div class="h4 secondary-text" *ngIf="flag_sheet2_errors==1">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.ROWS_NOTOK' | translate}}</div>
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <div class="font-size-54 font-weight-300 line-height-1 mt-8" *ngIf="flag_sheet2_errors==1">{{errores_CT.length}}</div>
                                    <mat-icon class="s-50 ml-20" *ngIf="flag_sheet2_errors==1">close</mat-icon>
                                </div>
                                <div class="h4 secondary-text" *ngIf="flag_sheet2_errors==1"><b>{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.MOREINFO' | translate}}</b></div>
                            </div>
                        </div>
                    </div>
                    <!--FIN SEGUNDA HOJA CON ERRORES-->
                    <mat-divider></mat-divider>
                    <div class="mt-20 mb-20">
                        <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.FILENAME' | translate}}</div>
                        <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{ file }}</div>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="mt-20 h2 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRFND.GUARDAR' | translate}}</div>
                    <button mat-raised-button class="warn mt-20" (click)="deleteAttachment(i,true)">
                        {{'CERTIFICAR.COLABORADORES.CARD_ERRFND.DELETE' | translate}}
                    </button>
                </div>

            </div>

            <!-- listado de errores -->
            <div *ngIf="errores.length > 0 || errores_CT.length > 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">
                <div class="mat-elevation-z3 p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <div fxLayout="row" fxLayoutAlign="space-between stretch" *ngIf="flag_sheet1_errors==1">
                        <h2 class="mt-0" *ngIf="flag_sheet1_errors==1">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.TITULO.3' | translate}}</h2>
                        <h2 class="mt-0" *ngIf="flag_sheet1_errors==1">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.TITULO.1' | translate}}{{errores.length}}</h2>
                        <h2 class="mt-0" *ngIf="flag_sheet1_errors==1">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.TITULO.2' | translate}}{{erroresTotales}}</h2>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="mt-20 mb-20" *ngIf="flag_sheet1_errors==1">
                        <!-- ERRORES DE HOJA NÚMERO 1-->
                        <mat-accordion>
                            <ng-container *ngFor="let error of errores; index as i;">
                                <mat-expansion-panel class="mb-20">
                                    <mat-expansion-panel-header class="accent-50">
                                        <mat-panel-title>
                                            <b>{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.ROW' | translate}}{{error.numeroFila}}</b>
                                            <b class="ml-20">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.ERRNUM' | translate}}{{error.listaErrores.length}}</b>
                                        </mat-panel-title>
                                        <mat-panel-description>
                                            {{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.SHOW' | translate}}
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    <div *ngFor="let detalleError of error.listaErrores" class="mat-elevation-z3 p-20 mt-20 mb-20" fxLayout="column" fxLayoutAlign="space-between stretch">
                                        <div fxLayout="row" fxLayoutAlign="space-between stretch">
                                            <div fxFlex="50">
                                                <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.TIPO' | translate}}</div>
                                                <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.ERRORES.'+detalleError.tipoError | translate}}</div>
                                            </div>
                                            <div fxFlex="50">
                                                <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.COLUMNA' | translate}}</div>
                                                <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{detalleError.columna}}</div>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="space-between stretch" class="mt-20">
                                            <div fxFlex="50">
                                                <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DESCR' | translate}}</div>
                                                <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DESCRIPCION.'+detalleError.tipoError | translate}}</b></div>
                                            </div>
                                            <div fxFlex="50">
                                                <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DATO' | translate}}</div>
                                                <div class="datoErroneo">{{detalleError.dato}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </ng-container>
                        </mat-accordion>
                        <!-- FIN DE ERRORES DE HOJA NÚMERO 1-->
                    </div>
                    <mat-divider></mat-divider>
                    <div fxLayout="row" fxLayoutAlign="space-between stretch" *ngIf="flag_sheet2_errors==1">
                        <h2 class="mt-0" *ngIf="flag_sheet2_errors==1">{{wsName_ct}}</h2>
                        <h2 class="mt-0" *ngIf="flag_sheet2_errors==1">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.TITULO.1' | translate}}{{errores_CT.length}}</h2>
                        <h2 class="mt-0" *ngIf="flag_sheet2_errors==1">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.TITULO.2' | translate}}{{erroresTotales_CT}}</h2>
                    </div>
                    <div class="mt-20 mb-20" *ngIf="flag_sheet2_errors==1">
                        <!-- ERRORES DE HOJA NÚMERO 2-->
                        <mat-accordion>
                            <ng-container *ngFor="let error of errores_CT; index as i;">
                                <mat-expansion-panel class="mb-20">
                                    <mat-expansion-panel-header class="accent-50">
                                        <mat-panel-title>
                                            <b>{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.ROW' | translate}}{{error.numeroFila}}</b>
                                            <b class="ml-20">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.ERRNUM' | translate}}{{error.listaErrores.length}}</b>
                                        </mat-panel-title>
                                        <mat-panel-description>
                                            {{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.INFO.SHOW' | translate}}
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    <div *ngFor="let detalleError of error.listaErrores" class="mat-elevation-z3 p-20 mt-20 mb-20" fxLayout="column" fxLayoutAlign="space-between stretch">
                                        <div fxLayout="row" fxLayoutAlign="space-between stretch">
                                            <div fxFlex="50">
                                                <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.TIPO' | translate}}</div>
                                                <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.ERRORES.'+detalleError.tipoError | translate}}</div>
                                            </div>
                                            <div fxFlex="50">
                                                <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.COLUMNA' | translate}}</div>
                                                <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{detalleError.columna}}</div>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="space-between stretch" class="mt-20">
                                            <div fxFlex="50">
                                                <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DESCR' | translate}}</div>
                                                <div class="h3 secondary-text"><b>{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DESCRIPCION.'+detalleError.tipoError | translate}}</b></div>
                                            </div>
                                            <div fxFlex="50">
                                                <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.DETALLE.DATO' | translate}}</div>
                                                <div class="datoErroneo">{{detalleError.dato}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </ng-container>
                        </mat-accordion>
                        <!-- FIN DE ERRORES DE HOJA NÚMERO 1-->
                    </div>



                </div>

            </div>

            <!-- pantalla "cargando" y "guardando" -->
            <div class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">
                <!--- cargando excel en front --->
                <div *ngIf="cargandoBD" class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.CARGA.TITULO' | translate}}</h2>
                    <mat-divider></mat-divider>
                    <div class="mt-20 mb-20">
                        <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.CARGA.INFO' | translate}}</div>
                        <mat-progress-bar mode="indeterminate" class="mt-20"></mat-progress-bar>
                    </div>
                </div>
                <!--- guardando registros en back --->
                <div *ngIf="guardandoBD" class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.GUARDA.TITULO' | translate}}</h2>
                    <mat-divider></mat-divider>
                    <div class="mt-20 mb-20">
                        <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.GUARDA.INFO' | translate}}</div>
                        <mat-progress-bar mode="indeterminate" class="mt-20"></mat-progress-bar>
                    </div>
                </div>
            </div>

        </ng-container>
    </ng-container>





    <!-- <div class="files-list" *ngFor="let file of files;let i=index"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" >
      <p>{{ file }}</p>
      <button class="delete-file accent" (click)="deleteAttachment(i,true)" mat-raised-button matTooltip="{{'CERTIFICAR.COLABORADORES.REMOVE' | translate}}">
        <mat-icon>delete</mat-icon>
      </button>
    </div> -->

    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
        <button *ngIf="!pasoCompleto && !cargando" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20" (click)="completarPaso()">
        <mat-icon>done</mat-icon>
        </button>

        <button *ngIf="pasoCompleto && !cargando" (click)="completarPaso()" mat-raised-button class="done mr-20">
        {{'CERTIFICAR.ADICIONALES.STATUS.DONE' | translate}}
        <mat-icon class="ml-20">done</mat-icon>
      </button>
      <button *ngIf="pasoCompleto && !cargando" (click)="desbloquearPasoColabNorma()" mat-fab aria-label=""
      matTooltip="{{'CERTIFICAR.COLABORADORES.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
      >
      <mat-icon>lock_open</mat-icon>
    </button>

    </div>

</div>
